import React from 'react';
import { SnowmanIcon } from './SnowmanIcon';
import { ASSISTANT_DISPLAY_NAME } from './constants';

interface WorkflowAssistantAvatarProps {
	loading?: boolean;
}

export const WorkflowAssistantAvatar: React.FC<WorkflowAssistantAvatarProps> = ({ loading }) => (
	<div
		className={loading ? 'chatbot-assistant-avatar-loading' : undefined}
		style={{
			width: 36,
			height: 36,
			borderRadius: '50%',
			background: 'linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexShrink: 0,
			position: 'relative',
			boxShadow: loading ? '0 0 0 3px rgba(21, 101, 192, 0.6)' : 'none',
		}}
		title={ASSISTANT_DISPLAY_NAME}
	>
		<SnowmanIcon size={38} />
	</div>
);
